import React from 'react'
import PropTypes from 'prop-types'
import SimpleCta from 'components/simple-cta'
import config from 'config'
import WidgetPage from 'components/hocs/widget-page'

const variations = {
    'compare-cards-all': 'Compare Cards',
    'compare-cards-student': 'Compare Cards',
    'compare-cards-secured': 'Compare Cards',
    'compare-cards-zero-percent': 'Compare Cards',
    'compare-cards-low-interest': 'Compare Cards',
    'compare-cards-balance-transfer': 'Compare Cards',
    'compare-cards-travel': 'Compare Cards',
    'compare-cards-cashback': 'Compare Cards',
    'compare-cards-rewards': 'Compare Cards',
    student: 'Compare Student Cards',
    secured: 'Compare Secured Cards',
    'zero-percent': 'Compare 0% APR Cards',
    'low-interest': 'Compare Low Interest Cards',
    'balance-transfer': 'Compare Balance Transfer Cards',
    travel: 'Compare Travel Cards',
    cashback: 'Compare Cashback Cards',
    rewards: 'Compare Rewards Cards',
  },
  urls = {
    'compare-cards-all': 'all-credit-cards',
    'compare-cards-student': 'student',
    'compare-cards-secured': 'secured',
    'compare-cards-zero-percent': 'zero-percent',
    'compare-cards-low-interest': 'low-interest',
    'compare-cards-balance-transfer': 'balance-transfer',
    'compare-cards-travel': 'travel',
    'compare-cards-cashback': 'cashback',
    'compare-cards-rewards': 'rewards',
    student: 'student',
    secured: 'secured',
    'zero-percent': 'zero-percent',
    'low-interest': 'low-interest',
    'balance-transfer': 'balance-transfer',
    travel: 'travel',
    cashback: 'cashback',
    rewards: 'rewards',
  },
  SimpleCtaApp = props => {
    const { variation } = props

    return (
      <SimpleCta
        url={`${config.credibleRoot}/credit-cards/${urls[variation]}`}
        variations={variations}
        large={variations[variation].length > 20}
        {...props}
      />
    )
  }

SimpleCtaApp.propTypes = {
  variation: PropTypes.string.isRequired,
}

export default WidgetPage(SimpleCtaApp)
